import styled from "styled-components";

export const EnquiryIdContainer = styled.div`
  display: flex;
  align-items: center;
`;
